
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/view-cart",
      function () {
        return require("private-next-pages/view-cart.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/view-cart"])
      });
    }
  